<script setup lang="ts">
/**
 * EmptyState — components.css 의 .empty-state 원자.
 *  아이콘 칩 + 제목 + 보조문구 + 선택 액션 슬롯.
 *  목록·검색 결과 0건 공통 표현. 아이콘은 icon slot 으로 교체 가능(기본 lucide Inbox).
 * 색은 토큰 경유.
 */
import { Inbox } from 'lucide-vue-next';

interface Props {
  /** 제목 */
  title?: string;
  /** 보조 설명 */
  description?: string;
}

withDefaults(defineProps<Props>(), {
  title: '아직 표시할 항목이 없습니다',
  description: '',
});
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center text-muted">
    <span
      class="flex h-14 w-14 items-center justify-center rounded-[14px] border border-line bg-bg-2 text-brand-muted"
    >
      <slot name="icon">
        <Inbox class="h-7 w-7" :stroke-width="1.6" />
      </slot>
    </span>
    <div class="text-[16px] font-bold text-brand">{{ title }}</div>
    <div v-if="description" class="text-[13.5px] leading-[1.6]">{{ description }}</div>
    <div v-if="$slots.action" class="mt-1">
      <slot name="action" />
    </div>
  </div>
</template>
